<template>
  <layout-main-inner title="通用设置">
    <layout-card-wrap>
      <el-row :gutter="20">
        <!-- <el-col :md="6">
          <friend-Share-card
            :vendorId="userInfo.orgId"
            :config="commonShare"></friend-Share-card>
        </el-col> -->
        <el-col :md="6">
          <point-cash-card
            :vendorId="userInfo.orgId"
            :config="point2Cash" />
        </el-col>
        <el-col :md="6">
          <integral-strategy-card
            :vendorId="userInfo.orgId"
            :config="integralStrategy"></integral-strategy-card>
        </el-col>
        <el-col :md="6">
          <point-card
            :config="point"></point-card>
        </el-col>
        <el-col :md="6">
          <pay-card :config="pay"></pay-card>
        </el-col>
        <!-- <el-col :md="6">
          <partner-card :config="partner"></partner-card>
        </el-col> -->
      </el-row>
      <!-- <el-col :md="6">
          <authorize-card authType="1"
            :config="official"></authorize-card>
        </el-col> -->
      <el-row :gutter="20">

        <!-- <el-col :md="6">
          <logistics-card :config="logistics"></logistics-card>
        </el-col> -->
        <el-col :md="6">
          <gifts-card :config="gifts"></gifts-card>
        </el-col>
        <el-col :md="6">
          <product-group :config="group"></product-group>
        </el-col>
      </el-row>
      <el-row :gutter="20">

        <!-- <el-col :md="6">
          <alert-card :config="alert"></alert-card>
        </el-col> -->
        <!-- <el-col :md="6">
          <manager-card :config="manager"></manager-card>
        </el-col> -->
        <!-- <el-col :md="6">
          <official-card :config="officialCard"></official-card>
        </el-col> -->
      </el-row>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
// import FriendShareCard from './busi/friend-share-card.vue'
import IntegralStrategyCard from './busi/integral-strategy-card.vue'
// import AuthorizeCard from './busi/authorize-card.vue' // AuthorizeCard
import PayCard from './busi/pay-card.vue'
// import LogisticsCard from './busi/logistics-card.vue' LogisticsCard
// import OfficialCard from './busi/official-card.vue'
import GiftsCard from './busi/gifts-card.vue'
import ProductGroup from './busi/product-group.vue'
// import PartnerCard from './busi/partner-card.vue'
// import ManagerCard from './busi/manager-card.vue'
// import AlertCard from './busi/alert-card.vue'
import { mapState } from 'vuex'
import PointCard from './busi/point-card.vue'
import PointCashCard from './busi/point-cash-card.vue'
export default {
  name: 'WxappSettings',
  components: { PayCard, GiftsCard, ProductGroup, PointCard, PointCashCard, IntegralStrategyCard },
  props: {},
  data() {
    return {
      commonShare: {
        title: '分享图片设置',
        info: '用于小程序端右上角分享入口的自定义设置',
        type: 1,
        // eslint-disable-next-line global-require
        image: require('./logo/share_fill.png')
      },
      point2Cash: {
        title: '积分折现设置',
        info: '用于现金购物时积分抵扣规则的设置',
        type: 1,
        // eslint-disable-next-line global-require
        image: require('./logo/share_fill.png')
      },
      // friendShare: {
      //   title: '邀请好友设置',
      //   info: ' 用于小程序端推荐好友送积分的自定义设置',
      //   type: 2,
      //   // eslint-disable-next-line global-require
      //   image: require('./logo/group_fill.png')
      // },
      integralStrategy: {
        title: '邀请合伙人',
        info: ' 用于小程序邀请合伙人页面的内容设置',
        type: 8,
        // eslint-disable-next-line global-require
        image: require('./logo/createtask_fill.png')
      },
      point: {
        title: '积分任务设置',
        info: ' 用于小程序端积分任务规则的自定义设置',
        type: 3,
        // eslint-disable-next-line global-require
        image: require('./logo/createtask_fill.png')
      },
      // authorize: {
      //   title: '小程序授权',
      //   info: ' 初次使用中质微服时请进行小程序授权',
      //   // eslint-disable-next-line global-require
      //   image: require('./logo/wx.png')
      // },
      gifts: {
        title: '赠送礼物',
        info: '商品赠送好友开关及礼物卡片的设计',
        // eslint-disable-next-line global-require
        image: require('./logo/wx.png')
      },
      // official: {
      //   title: '公众号授权',
      //   info: ' 初次使用中质微服时请进行公众号授权',
      //   image: require('../../assets/images/gzh.png')
      // },
      // officialCard: {
      //   title: '公众号入口',
      //   info: '设置小程序页面显示公众号组件',
      //   image: require('../../assets/images/gzhrk.png')
      // },
      pay: {
        title: '支付设置',
        info: '创建现金商品前，请先配置商户信息',
        // eslint-disable-next-line global-require
        image: require('./logo/pay.png')
      },
      // logistics: {
      //   title: '物流设置',
      //   info: '企业合作物流公司信息的设置',
      //   // eslint-disable-next-line global-require
      //   image: require('./logo/logistics.png')
      // },
      group: {
        title: '商品分组',
        info: '设置自定义分组，可用商城中的分类筛选',
        // eslint-disable-next-line global-require
        image: require('./logo/cate.png')
      },
      partner: {
        title: '合伙人业绩',
        info: '设置业绩分段收益,如0-100（0.1%）,101-1000(0.2%)等',
        // eslint-disable-next-line global-require
        image: require('./logo/partner.png')
      },
      manager: {
        title: '企业管理员',
        info: '将某个会员打上企业管理员标记，用于部分特殊功能',
        // eslint-disable-next-line global-require
        image: require('./logo/manager.png')
      },
      alert: {
        title: '弹窗设置',
        info: '首页弹窗，设置后可以向用户展示推荐信息（商品/优惠券）',
        // eslint-disable-next-line global-require
        image: require('./logo/alert.png'),
        type: 7
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  }
}
</script>
